import { LoginEndpoint } from "@/views/loyalty/shared/endpoint_services/login-endpoint-service"

export class LoginService {
    constructor () {
        this.loginEndpoint = new LoginEndpoint()
    }

    async getToken () {
        return this.loginEndpoint.check()
    }

    async createLogin (login) {
        const response = await this.loginEndpoint.create_login(login)
        if (response.access_token) {
            localStorage.setItem('token', response.access_token)
        }
        return { data: response.data, error: response.detail }
    }

    async getLogin (login) {
        const response = await this.loginEndpoint.get_login(login)
        if (response.access_token) {
            localStorage.setItem('token', response.access_token)
        }
        return { data: response.data, error: response.detail }
    }
}
